<template>
    <div>
        <p class="fw-semibold fs-5 mb-3">
            {{ message }}
        </p>

        <div class="border-top pt-2">
            <div>
                <p>{{ $t("device.label") }}: <strong>{{ notification.device_name }}</strong></p>
            </div>
            <div>
                <p>{{ $t("notifications.fall.time") }}: <strong>{{ $d(new Date(notification.data.timestamp), "long") }}</strong></p>
            </div>
            <div>
                <p>{{ $t("device.batteryStatus") }}: <strong>{{ batteryLevel }} %</strong></p>
            </div>
            <div>
                <p>{{ $t("notifications.fall.coordinates") }}: <strong>{{ notification.data.latitude }}, {{ notification.data.longitude }}</strong></p>
            </div>
            <div>
                <MapView
                    ref="map"
                    v-show="notification.data.latitude != null && notification.data.longitude != null"
                    :device="{
                        latitude: notification.data.latitude,
                        longitude: notification.data.longitude,
                    }"
                />
            </div>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button
                v-if="!notification.is_resolved"
                class="btn btn-success btn-sm me-2"
                @click="$emit('resolved')"
                :title="$t('notifications.markAsResolved')"
            >
                <span class="text-white fs-6 fw-bold p-3">{{ $t("utils.solve") }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import MapView from '@/components/dashboard/MapView.vue';

export default {
    props: {
        notification: Object,
    },
    components: {
        MapView,
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.map?.invalidate()
            }, 300)
        })
    },
    computed: {
        message() {
            return this.$t(`notifications.fall.message`, {
                device: this.notification.device_name,
            })
        },
        batteryLevel() {
            return (this.notification.data.battery_level * 100).toFixed(0);
        }
    }
}
</script>